import React from "react";
import { Flex, Text, toast } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { GetCommentThreadsQuery } from "#graphql/supergraphTypes";
import { SPACING } from "#utils/spacing";
import { COMMENT_ERROR_TOAST_ID } from "../../constants";
import * as styles from "./styles_vanilla.css";
import { formatCommentDate, convertAdfToHtml } from "./utils";

type CommentCardProps = {
  comment: GetCommentThreadsQuery["commentThreads"]["comments"][number];
  checkedCommentIds: React.MutableRefObject<Set<string>>;
  isLast?: boolean;
};

export const CommentCard: React.FC<CommentCardProps> = ({
  comment,
  checkedCommentIds,
  isLast = false,
}) => {
  const renderedHtml = convertAdfToHtml(comment.body);

  if (!checkedCommentIds.current.has(comment.id)) {
    checkedCommentIds.current.add(comment.id);

    if (renderedHtml === "" && !toast.isActive(COMMENT_ERROR_TOAST_ID)) {
      toast.error("Some comments could not be displayed", {
        toastId: COMMENT_ERROR_TOAST_ID,
      });
    }
  }

  return (
    <Flex className={styles.commentCard} gap={SPACING.MEDIUM}>
      <Flex
        flexDirection="column"
        alignItems="center"
        className={isLast ? styles.commentIconColumnLast : styles.commentIconColumn}
        data-testid="comment-icon-column"
      >
        <div className={styles.commentIcon} />
      </Flex>

      <Flex flexDirection="column" gap={SPACING.X_SMALL} className={styles.commentContent}>
        <Flex flexDirection="column" gap={SPACING.X_SMALL} className={styles.commentHeader}>
          <Flex flexDirection="row" alignItems="center" gap={SPACING.SMALL}>
            <Text variant="strong-md" color={Colors.Neutral900}>
              {comment.author.displayName}
            </Text>
          </Flex>
          <Text variant="secondary-sm" color={Colors.Neutral600}>
            {formatCommentDate(comment.created)}
          </Text>
        </Flex>

        <div
          className={styles.commentBody}
          dangerouslySetInnerHTML={{ __html: renderedHtml }}
        />

        {comment.updated && comment.created !== comment.updated && (
          <Text
            variant="secondary-sm"
            color={Colors.Neutral500}
            className={styles.commentMetadata}
          >
            Edited {formatCommentDate(comment.updated)}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
